module.exports = __webpack_public_path__ + "img/code4.d40e1a13.png";